/* eslint-disable no-param-reassign */
import produce from 'immer';
import create from 'zustand';
import { pipe } from 'ramda';
import { devtools } from 'zustand/middleware';

const immer = config => (set, get, api) =>
  config(
    (partial, replace) => {
      const nextState =
        typeof partial === 'function' ? produce(partial) : partial;
      return set(nextState, replace);
    },
    get,
    api
  );

const customDevtools = (store, config) => {
  const customConfig = {
    ...config,
    stateSanitizer: state => ({
      ...state,
    }),
  };
  return devtools(store, customConfig);
};

const createTransferAccountsTabStore = pipe(immer, customDevtools, create);

const TransferAccountsTabStore = createTransferAccountsTabStore(set => ({
  selectedTransferAccount: {},
  setSelectedTransferAccount: param =>
    set(state => {
      state.selectedTransferAccount = { ...param };
    }),
}));

export default TransferAccountsTabStore;
